import { styled } from "styled-components";

export const ReviewInputContainer = styled.div`
  margin: 100px 0 0 0;
  position: relative;
`;
